import { render, staticRenderFns } from "./AmetrasDurationFieldTemplate.vue?vue&type=template&id=56a0df7f&"
import script from "./AmetrasDurationFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasDurationFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasDurationFieldTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VMenu,VTextField,VTimePicker})
